export enum EPresentationType {
  UNIT = 'UND',
  PACKAGE = 'PQT',
}
export enum EProductType {
  ALICORP = 1,
  ALLIED,
}
